// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kgxa","left":"styles_left__DVPlY"};